__turbopack_context__.v({
  "emblaContainer": "styles-module__2TIL2W__emblaContainer",
});
